import { render, staticRenderFns } from "./ScanInstruction.vue?vue&type=template&id=85fe9b9e&scoped=true&lang=pug"
import script from "./ScanInstruction.vue?vue&type=script&lang=js"
export * from "./ScanInstruction.vue?vue&type=script&lang=js"
import style0 from "./ScanInstruction.vue?vue&type=style&index=0&id=85fe9b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe9b9e",
  null
  
)

export default component.exports